import t from "@/lang/lang";
import { Dialog, DialogContent } from "@/shared/components/ui/dialog";
import {
  CommonDialogFooter,
  CommonDialogHeader,
  CommonDialogTrigger,
} from "@/shared/components/dialog/dialog-common";
import { Trash2 } from "lucide-react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { UUID } from "@bitory-gmbh/nidavellir";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useRelationshipsRelationshipDeleteSeriesMutation } from "@/services/backend/relationships/api/service";

export function DeleteSeriesDialog({
  relationshipId,
  seriesId,
}: {
  relationshipId: UUID;
  seriesId: UUID;
}) {
  const [open, setOpen] = useState(false);
  const [deleteSeries, { isLoading, error, isSuccess, reset }] =
    useRelationshipsRelationshipDeleteSeriesMutation();

  useEffect(() => {
    if (isSuccess) {
      reset();
      toast.success(t("Serie gelöscht"));
      setOpen(false);
    }
  }, [isSuccess, reset]);

  const doDelete = () => {
    if (isLoading) {
      return;
    }

    deleteSeries({ id: relationshipId, seriesId });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <CommonDialogTrigger
        icon={Trash2}
        label={t("Serie löschen")}
        variant="destructive"
      />
      <DialogContent>
        <CommonDialogHeader
          title={t("Serie löschen?")}
          description={t(
            "Es werden nur die zukünftigen, unerfüllten Sollstellungen gelöscht.",
          )}
        />
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={doDelete}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
